// 页面名称
const pageType = {
  // OnlineCvPreview: 'onlineCvPreview', //在线简历
  CvEditor: 'cvEditor', //简历编辑

  // JianlimobanList: 'jianlimobanList', // 简历模板-列表
  // JianlimobanSearch: 'jianlimobanSearch', // 简历模板-搜索
  // JianlimobanDetails: 'jianlimobanDetail', // 简历模板-详情

  JobsList: 'jobList', //职位-列表
  JobsSearch: 'jobSearch', //职位-搜索
  // JobDetail: 'jobDetail', //职位-详情

  JobsList1: 'campusList', //校招-列表
  // search: 'campusSearch', //校招-搜索
  JobDetail: 'campusDetail', //校招-详情

  // CompanyList: 'companyList', //公司-列表
  // CompanySearch: 'companySearch', //公司-搜索
  // CompanyDetails: 'companyDetail', //公司-详情

  // blog: 'blogList', //攻略-列表
  // BlogList: 'blogList', //攻略-列表
  // 'blog-stu-cv': 'blogList', //攻略-列表
  // 'blog-apply': 'blogList', //攻略-列表
  // 'blog-cv-content': 'blogList', //攻略-列表
  // 'blog-interview': 'blogList', //攻略-列表
  // 'blog-format': 'blogList', //攻略-列表
  // 'blog-expirence': 'blogList', //攻略-列表
  // BlogSearch: 'blogSearch', //攻略-搜索
  // BlogDetail: 'blogDetail', //攻略-详情
  
  // communityList: 'communityList', //bbs-列表
  // BBSSearch: 'communitySearch', //bbs-搜索
  // CommunityDetail: 'communityDetail', //bbs-详情
  // CommunityTopic: 'communityTopicList', //bbs-专题列表
  // jobCategoryDetail: 'jobCategoryDetail', //职类页面
}
const getPageType = (name) => {
  let type = pageType[name] || ''
  return type
}

// 默认数据
let defaultReportData = {
  job_token: '', //职位token
  job_search_key: '', //职位搜索词
  job_pn: '', //职位-页数

  campus_token: '', //校招token
  campus_search_key: '', //校招搜索词
  campus_pn: '', //校招-页数

  cv_token: '', //简历token

  resume_template_token: '', //简历模板token
  resume_template_cn_token: '', //简历模板token
  resume_template_en_token: '', //简历模板token
  resume_template_pn: '', //简历模板-页数
  resume_template_search_key: '',  //简历模板搜索词
  resume_template_search_tag: '', //简历模板-tag

  blog_token: '', //攻略token
  blog_search_key: '', //攻略搜索词
  blog_pn: '', //攻略-页数
  blog_type: '', //攻略-类型

  topic_id: '', //bbs帖子主题id
  community_id: '', //bbs-token
  community_search_key: '', //bbs搜索词
  community_pn: '', //bbs-页数
  profession_id: '', //职类页面
  
  company_token: '', //公司token
  company_search_key: '', //公司搜索词
  company_pn: '', //公司-页数
}

// 解析url路由
const getRouteData = (options) =>{
  let newDefaultData = JSON.parse(JSON.stringify(defaultReportData));
  let { params={}, name, query={} } = options
  console.log('name=>>>>>>', name)
  // console.log('options>>>>>>>', options)
  try {
    
    switch(name){
      // case 'Cv' :
      case 'CvEditor' :
        newDefaultData.cv_token = params.token || ""
        break;
      // case 'JianlimobanDetails': //简历模板-详情
      //   newDefaultData.resume_template_token = params.token || ""
      //   break;
      // case 'JianlimobanSearch': //简历模板-搜索
      //   newDefaultData.resume_template_pn = getPageNumber(params.pn)
      //   newDefaultData.resume_template_search_tag = params.tag || ""
      //   newDefaultData.resume_template_search_key = query.keyword || ""
      //   break;

      // case 'JobsList1': //职位-列表
      //   newDefaultData.job_pn = getPageNumber(params.pn) || ""
      //   break;
      case 'JobsSearch': //职位-列表
        newDefaultData.job_search_key = query.keyword || ""
        newDefaultData.job_pn = query.from ? Number(query.from) : 1
        break;
      // case 'JobDetail': //职位-详情
      //   newDefaultData.job_token = params.token || ""
      //   break;

      // case 'scJobsList1'://校招-列表
      //   newDefaultData.campus_pn = getPageNumber(params.pn) || 1
      //   break;
      case 'JobDetail': //校招-详情
        newDefaultData.campus_token = params.token || ""
        break;

      // case 'communityList': //bbs-列表
      //   newDefaultData.community_pn = getPageNumber(params.pn) || 1
      //   break;
      // case 'CommunityDetail': //bbs-详情
      //   newDefaultData.community_id = params.articleId || ""
      //   break;
      // case 'CommunityTopic': //bbs帖子主题
      //   newDefaultData.topic_id = params.topicId || ""
      //   newDefaultData.community_pn = getPageNumber(params.pn) || 1
      //   break;
      // case 'PostClass': //职类页面
      //   newDefaultData.profession_id = params.profession_id || ""
      //   break;
      
      // case 'CompanyList': //公司-搜索
      //   newDefaultData.company_search_key = query.keyword || ""
      //   newDefaultData.company_pn = getPageNumber(query.form)
      //   break;
      // case 'CompanyDetails': //公司详情
      //   newDefaultData.company_token = params.token || ""
      //   break;
      
      // case 'blog': //攻略-列表
      // case 'BlogList': //攻略-列表
      // case 'blog-stu-cv': //攻略-列表
      // case 'blog-apply': //攻略-列表
      // case 'blog-cv-content': //攻略-列表
      // case 'blog-interview': //攻略-列表
      // case 'blog-format': //攻略-列表
      // case 'blog-expirence': //攻略-列表
      //   newDefaultData.blog_search_key = query.search || ""
      //   newDefaultData.blog_pn = getPageNumber(params.pn)
      //   newDefaultData.blog_type = name || 'blog'

    }
  } catch (error) {}
  console.log('newDefaultData=>>',newDefaultData)
  return newDefaultData
}

// 获取页码
const getPageNumber = (pn) => {
  pn = pn ? String(pn).replace(/.*?(\d{1,}).*/gim, '$1') : '';
  return pn ? parseInt(pn) : 1;
}

export {
  defaultReportData,
  getRouteData,
  getPageType,
}